import { useSegmentAnalytics } from "./useSegmentAnalytics";

type ExportCSVEvent = {
  searchQuery: string;
  fromDate: string;
  toDate: string;
};

export type LeadsPageAnalytics = {
  trackTableSearchEvent: (searchQuery: string) => void;
  trackTableExportCSVEvent: (event: ExportCSVEvent) => void;
};

export const useLeadsPageAnalytics = () => {
  const {
    trackButtonClickEvent,
    trackOptionClickEvent,
    trackHoverEvent,
    trackInputChangeEvent,
  } = useSegmentAnalytics();

  const trackTableExportCSVEvent = ({
    searchQuery,
    fromDate,
    toDate,
  }: ExportCSVEvent) =>
    trackButtonClickEvent({
      label: "Export CSV",
      location: "Leads table",
      extraProperties: {
        search_query: searchQuery,
        to_date: toDate,
        from_date: fromDate,
      },
    });

  const trackTableSearchEvent = (searchQuery: string) =>
    trackInputChangeEvent({
      label: "Leads",
      location: "Leads",
      extraProperties: {
        link_text: "Search field",
        input_value: searchQuery,
      },
    });

  const trackDateRangeChangeEvent = (fromDate: string, toDate: string) => {
    trackOptionClickEvent({
      label: "Leads",
      location: "Leads",
      extraProperties: {
        date: [fromDate, toDate],
      },
    });
  };

  const trackDropdownStatusChangeEvent = (status: string[]) =>
    trackOptionClickEvent({
      label: "Status",
      location: "Leads table",
      extraProperties: {
        status,
      },
    });

  const trackStatusTooltipEvent = (status: string, isMobile: boolean) => {
    if (isMobile) {
      trackButtonClickEvent({
        label: "Status tooltip",
        location: "Leads table",
        extraProperties: {
          status,
          link_text: "Tool tip icon",
        },
      });
    } else {
      trackHoverEvent({
        label: "Tool tip",
        location: "Leads",
        extraProperties: {
          status,
        },
      });
    }
  };

  const trackInPogressTooltipHoverEvent = (isMobile: boolean) => {
    if (isMobile) {
      trackButtonClickEvent({
        label: "In progress tooltip",
        location: "Leads table",
      });
    } else {
      trackHoverEvent({
        label: "In progress tooltip",
        location: "Leads table",
      });
    }
  };

  return {
    trackTableSearchEvent,
    trackTableExportCSVEvent,
    trackDateRangeChangeEvent,
    trackDropdownStatusChangeEvent,
    trackStatusTooltipEvent,
    trackInPogressTooltipHoverEvent,
  };
};
